import dayjs from 'dayjs';
import {
  type AssetLevelInputType,
  type FleetLevelInputType,
} from '../types/input-steps.types';

function validateNumberField(
  value: unknown,
  {
    required = true,
    min = -Infinity,
    max = Infinity,
    label,
  }: { required?: boolean; min?: number; max?: number; label: string }
): string | null {
  if (required && (value === '' || value === null || value === undefined)) {
    return `${label} is required`;
  }
  const num = Number(value);
  if (isNaN(num)) return `${label} must be a number`;
  if (num < min || num > max)
    return `${label} must be between ${min} and ${max}`;
  return null;
}

export const validateFleetLevelInput = (fleet: FleetLevelInputType) => {
  const errors: Record<string, string> = {};

  const idleError = validateNumberField(fleet.excessIdling, {
    min: 0,
    max: 100,
    label: 'Excess Idling',
  });
  if (idleError) errors.excessIdling = idleError;

  const tolError = validateNumberField(fleet.lunchTolerance, {
    min: 0,
    max: 600,
    label: 'Tolerance',
  });
  if (tolError) errors.lunchTolerance = tolError;

  return errors;
};

export const validateAssetsLevelInput = (assets: AssetLevelInputType[]) => {
  const errors: Record<string, Record<string, string>> = {};

  assets.forEach((asset) => {
    const e: Record<string, string> = {};

    if (!asset.startTime) e.startTime = 'Required';
    if (!asset.endTime) e.endTime = 'Required';

    if (asset.startTime && asset.endTime) {
      const start = dayjs(asset.startTime);
      let end = dayjs(asset.endTime);
      // Overnight shifts: if end appears before start, treat end as next day
      if (end.isBefore(start)) end = end.add(1, 'day');
      if (end.isSame(start))
        e.endTime = 'Start and end time cannot be the same.';
    }

    if (!asset.lunchStart) e.lunchStart = 'Required';
    if (!asset.lunchEnd) e.lunchEnd = 'Required';

    if (asset.lunchStart && asset.lunchEnd) {
      const lunchStart = dayjs(asset.lunchStart);
      const lunchEnd = dayjs(asset.lunchEnd);
      if (lunchEnd.isBefore(lunchStart)) e.lunchEnd = 'Invalid range.';
    }

    const capError = validateNumberField(asset.capacity, {
      min: 0,
      label: 'Capacity',
    });
    if (capError) e.capacity = capError;

    if (Object.keys(e).length > 0) errors[asset.id] = e;
  });

  return errors;
};
